// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface CheckoutProps {
    contentWrapper?: InjectableCss;
}
export const checkoutProps: CheckoutProps = {
    contentWrapper: {
        css: css`
            padding: ${pxToRem(24)};
            border: 1px solid ${getColor("common.border")};
            border-radius: ${pxToRem(10)};
        `,
    },
};
